import { MutableRefObject, useRef } from 'react';

import { NwProductsExtensionsServicesTypes } from '../../services/NwProductsExtensionsServices/APIService';
import { NwProductsExtensionsServices } from '../../services/NwProductsExtensionsServices/APIService/index.api';
import { networkCallWithApisauceWithHeaders } from '../../utils/AuthAPIUtils';

import { usePaymentsRefreshAuthTokens } from '../usePaymentsRefreshAuthTokens';

interface NwProductsExtensionsServiceInstance {
  nwProductsExtensionsServiceInstance: NwProductsExtensionsServicesTypes;
}

const useNwProductsExtensionsService =
  (): NwProductsExtensionsServiceInstance => {
    const { refreshTokenApi, getRefreshToken, getAccessToken } =
      usePaymentsRefreshAuthTokens();
    const NwProductsExtensionsServiceRef: MutableRefObject<NwProductsExtensionsServicesTypes | null> =
      useRef(null);

    if (NwProductsExtensionsServiceRef.current === null) {
      NwProductsExtensionsServiceRef.current = new NwProductsExtensionsServices(
        networkCallWithApisauceWithHeaders({
          refreshAuthTokensAPI: refreshTokenApi,
          getAccessToken,
          getRefreshToken
        })
      );
    }
    return {
      nwProductsExtensionsServiceInstance:
        NwProductsExtensionsServiceRef.current
    };
  };

export { useNwProductsExtensionsService };
